/**
 * Jean Paul — Endorser detail page controller
 * Handles: the video lightbox (opened from the hero play icon or the gallery
 *          video tile) and the gallery image lightbox.
 * Companion to assets/endorsers.js (grid quick-view) — kept as its own file
 * because it drives a full server-rendered page, not the grid's JSON-fed modal.
 *
 * REBUILD 2026-09-01: replaced the old hero-video / gallery-carousel logic
 * with tab switching + a single shared video lightbox, matching the new
 * compact-header + ABOUT/GEAR/MEDIA layout in sections/main-endorser.liquid.
 * REDESIGN 2026-10-29: tabs and share row removed from the page, so their
 * handlers are gone too.
 */
(function () {
  'use strict';

  // ── Video URL parsing (same approach as endorsers.js) ───────────────────────
  function parseVideo(url) {
    if (!url) return null;
    var yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|v\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
    if (yt) {
      return {
        embedUrl: 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0'
      };
    }
    var vi = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vi) {
      return {
        embedUrl: 'https://player.vimeo.com/video/' + vi[1] + '?autoplay=1'
      };
    }
    return null;
  }

  // ── Video lightbox — shared by the hero play icon and the gallery video tile ──
  var lightbox = document.getElementById('EndorserVideoLightbox');
  if (lightbox) {
    var embedHost = document.getElementById('EndorserVideoLightboxEmbed');

    var openVideo = function (url) {
      var video = parseVideo(url);
      if (!video || !embedHost) return;
      embedHost.innerHTML = '';
      var iframe = document.createElement('iframe');
      iframe.src = video.embedUrl;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.setAttribute('title', 'Endorser video');
      embedHost.appendChild(iframe);
      lightbox.removeAttribute('hidden');
    };

    var closeVideo = function () {
      lightbox.setAttribute('hidden', '');
      if (embedHost) embedHost.innerHTML = '';
    };

    lightbox.querySelectorAll('[data-close]').forEach(function (el) {
      el.addEventListener('click', closeVideo);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !lightbox.hasAttribute('hidden')) closeVideo();
    });

    var playTriggers = document.querySelectorAll('#EndorserPlayVideoBtn, .js-media-video');
    playTriggers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        openVideo(btn.dataset.videoUrl);
      });
    });
  }

  // ── Image lightbox — gallery photo tiles, left/right cycling ─────────
  // Separate from the video lightbox above: the video tile keeps openVideo().
  // Every .js-media-image tile's data-full attribute feeds the cycle, in DOM
  // order (which matches e_gallery.value's order), so no embedded JSON is
  // needed to know "all the images."
  var imageLightbox = document.getElementById('EndorserImageLightbox');
  if (imageLightbox) {
    var imageLightboxImg = document.getElementById('EndorserImageLightboxImg');
    var imageTiles = Array.prototype.slice.call(document.querySelectorAll('.js-media-image'));
    var imageUrls = imageTiles.map(function (tile) { return tile.dataset.full; });
    var currentImageIndex = 0;

    var showImage = function (index) {
      if (!imageUrls.length) return;
      currentImageIndex = (index + imageUrls.length) % imageUrls.length;
      if (imageLightboxImg) {
        var tileImg = imageTiles[currentImageIndex].querySelector('img');
        imageLightboxImg.src = imageUrls[currentImageIndex];
        imageLightboxImg.alt = tileImg ? tileImg.alt : '';
      }
    };

    var openImage = function (index) {
      showImage(index);
      imageLightbox.removeAttribute('hidden');
    };

    var closeImage = function () {
      imageLightbox.setAttribute('hidden', '');
      if (imageLightboxImg) imageLightboxImg.src = '';
    };

    imageTiles.forEach(function (tile, index) {
      tile.addEventListener('click', function () {
        openImage(index);
      });
    });

    imageLightbox.querySelectorAll('[data-close]').forEach(function (el) {
      el.addEventListener('click', closeImage);
    });

    var imagePrevBtn = document.getElementById('EndorserImageLightboxPrev');
    var imageNextBtn = document.getElementById('EndorserImageLightboxNext');
    if (imagePrevBtn) imagePrevBtn.addEventListener('click', function () { showImage(currentImageIndex - 1); });
    if (imageNextBtn) imageNextBtn.addEventListener('click', function () { showImage(currentImageIndex + 1); });

    document.addEventListener('keydown', function (e) {
      if (imageLightbox.hasAttribute('hidden')) return;
      if (e.key === 'Escape') closeImage();
      if (e.key === 'ArrowLeft') showImage(currentImageIndex - 1);
      if (e.key === 'ArrowRight') showImage(currentImageIndex + 1);
    });
  }
}());
